import { InferOutput, number } from 'valibot'

export type PlayerId = InferOutput<typeof PlayerIdSchema>

export const PlayerIdSchema = number()
